export default __webpack_public_path__ + "static/media/cloud-web.5e4a92be.svg";